module.exports = __webpack_public_path__ + "img/sphere10-graph.1595c3d0.png";